export default {
  'user-register-result.login.userName': '用户名',
  'user-register-result.login.password': '密码',
  'user-register-result.login.message-invalid-credentials': '账户或密码错误（admin/ant.design）',
  'user-register-result.login.message-invalid-verification-code': '验证码错误',
  'user-register-result.login.tab-login-credentials': '账户密码登录',
  'user-register-result.login.tab-login-mobile': '手机号登录',
  'user-register-result.login.remember-me': '自动登录',
  'user-register-result.login.forgot-password': '忘记密码',
  'user-register-result.login.sign-in-with': '其他登录方式',
  'user-register-result.login.signup': '注册账户',
  'user-register-result.login.login': '登录',
  'user-register-result.register.register': '注册',
  'user-register-result.register.get-verification-code': '获取验证码',
  'user-register-result.register.sign-in': '使用已有账户登录',
  'user-register-result.register-result.msg': '你的账户：{email} 注册成功',
  'user-register-result.register-result.activation-email':
    '激活邮件已发送到你的邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。',
  'user-register-result.register-result.back-home': '返回首页',
  'user-register-result.register-result.view-mailbox': '查看邮箱',
  'user-register-result.navBar.lang': '语言',
};
